import { SHOWCASE_VIDEO } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Section } from "../layout/Section";

import styles from "./VideoShowcase.module.css";

export function VideoShowcase() {
  const { copy } = useLocale();

  return (
    <Section
      id="video"
      eyebrow={copy.videoShowcase.eyebrow}
      title={copy.videoShowcase.title}
      subtitle={copy.videoShowcase.subtitle}
      className={styles.section}
    >
      <div className={styles.frame}>
        <div className={styles.glow} aria-hidden="true" />
        <div className={styles.player}>
          <iframe
            className={styles.iframe}
            src={SHOWCASE_VIDEO.embedUrl}
            title={copy.videoShowcase.iframeTitle}
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen wake lock"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
      <p className={styles.caption}>
        <a
          className={styles.link}
          href={SHOWCASE_VIDEO.pageUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {copy.videoShowcase.openOnVk}
        </a>
      </p>
    </Section>
  );
}
